import { useEffect } from 'preact/hooks';
import { login, getProfile, logout } from '../redux/authen/action';
import { ROUTES_PATH, ROUTE_LOGIN, ROUTE_LOGIN_MANUAL } from '../resources/routes-name';
import { navigateTo, windowNavigateReplaceTo } from '../utils/navigation';
import { useDispatch } from 'react-redux';
import { getCookies } from '../store/useCookies';

export const useAuthEffect = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // getProfile();
  }, [dispatch]);
};

export const useAuthLogin = () => {
  const dispatch = useDispatch();

  function toLogin() {
    windowNavigateReplaceTo({ pathname: ROUTE_LOGIN });
  }

  const onLogin = async (values) => {
    dispatch(login(values));
  };

  function checkLoginToken() {
    // if (!getCookies('accessToken')) {
    // open this and comment below
    const accessToken = getCookies('accessToken');
    if (accessToken) {
      return dispatch(getProfile());
    }
    return dispatch(logout());
  }

  function redirectToMain() {
    const accessToken = getCookies('accessToken');
    if (accessToken) {
      // open this and comment below
      // if (!getCookies('accessToken')) {
      navigateTo({ pathname: ROUTE_LOGIN_MANUAL });
    }
  }

  return {
    toLogin,
    checkLoginToken,
    redirectToMain,
    onLogin,
  };
};
